jQuery(function($) {
	//Slider
	$('.integrations-slider').slick({
		infinite: true,
  		slidesToShow: 6,
		centerMode: true,
		centerPadding: '10%',
		arrows: false,
		speed: 5000,
		autoplay: true,
		autoplaySpeed: 0,
		cssEase: 'linear',
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 4,
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				centerPadding: '0px',
			  }
			},	
			{
				breakpoint: 576,
				settings: {
				  slidesToShow: 2,
				}
			  },					
		]
	});

	if ($(window).width() > 768) {
		$('.review-slider-new-design, .create-reports-slider').on('init afterChange', function(){
			$('.review-slider-new-design .slick-slide, .create-reports-slider .slick-slide').css('opacity', 0.5).attr('aria-hidden', 'true');
			$('.review-slider-new-design .slick-current, .create-reports-slider .slick-current').css('opacity', 1).removeAttr('aria-hidden');
			$('.review-slider-new-design .slick-current').next().css('opacity', 1).removeAttr('aria-hidden');
		});
	} 
	$('.review-slider-new-design, .create-reports-slider').on('init afterChange', function(){
		let maxHeight = 0;
		$('.review-slider-new-design .slick-slide, .create-reports-slider .slick-slide').each(function() {
			let slideHeight = $(this).outerHeight();
			if (slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});
		$('.review-slider-new-design .slick-slide > div, .create-reports-slider .slick-slide > div').css('height', maxHeight + 'px');
	});

	$('.review-slider-new-design').slick({
		infinite: true,
  		slidesToShow: 2,
		centerMode: false,
		rtl: $('html').attr('dir') === 'rtl',
		focusOnSelect: true,
		responsive: [			
			{
			  	breakpoint: 992,
			  	settings: {
					slidesToShow: 1,
			  }
			}						
		]
	});
	
	$('.review-slider').slick({
		infinite: true,
  		slidesToShow: 3,
		centerMode: true,
		centerPadding: '0px',
		responsive: [			
			{
			  	breakpoint: 992,
			  	settings: {
					slidesToShow: 1,
					centerPadding: '20%',
			  }
			},
			{
			  	breakpoint: 768,
			  	settings: {
					centerMode: false,
					slidesToShow: 1,
			  }
			},						
		]
	});

	$('.review-slider-1').slick({
		infinite: true,
  		slidesToShow: 2,
		responsive: [			
			{
			  	breakpoint: 992,
			  	settings: {
					slidesToShow: 1,
			  }
			},					
		]
	});

	$('.deployment-options-slider').slick({
		infinite: true,
  		slidesToShow: 3,
		autoplay: false,
		responsive: [			
			{
			  	breakpoint: 992,
			  	settings: {
					slidesToShow: 2,
			  }
			},
			{
			  	breakpoint: 767,
			  	settings: {
					slidesToShow: 1,
			  }
			},						
		]
	});

	$('.new-design .blog-slider').slick({
		infinite: true,
  		slidesToShow: 3,
		responsive: [
			{
			  breakpoint: 1025,
			  settings: {
				slidesToShow: 1,
			  }
			},						
		]
	});

	$('.new-design .pages-slider .row-slider').slick({
		infinite: true,
  		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1025,
				settings: {
				  slidesToShow: 2,
				}
			  },	
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
			  }
			},						
		]
	});

	$('.blog-slider, .resources-slider').not('.slick-initialized').slick({
		infinite: true,
  		slidesToShow: 3,
		responsive: [
			{
			  breakpoint: 1024,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 1,
			  }
			},						
		]
	});

	$('.rating-slider').slick({
  		slidesToShow: 3,
		responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 2,
			  }
			},
			{
				breakpoint: 1024,
				settings: {
				  slidesToShow: 3,
				}
			  },
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 2,
			  }
			},						
		]
	});	

	$('.white-paper').slick({
		infinite: false,
  		slidesToShow: 1,
		autoplay: false,
	});

	$('.events-slider').slick({
	arrows: true,
	infinite: true,
	slidesToShow: 3,
  	centerMode: false,
		responsive: [
			{
				breakpoint: 991,
				settings: {
				slidesToShow: 1,
				arrows: false,
				}
			},						
		]
  });
  
  $('.case-stadies-slider').slick({
	infinite: true,
	centerPadding: '5%',
	  slidesToShow: 1,
	rtl: $('html').attr('dir') === 'rtl',
	dots: true
	});

	//years slider

	$('.years-slider-nav').slick({
		infinite: true,
  		slidesToShow: 1,
		asNavFor: '.years-slider',
  		focusOnSelect: true,
		mobileFirst: true,
		responsive: [
			{
			  breakpoint: 767,
			  settings: {
				slidesToShow: 4,
			  }
			},
			{
				breakpoint: 991,
				settings: {
				  slidesToShow: 12,
				}
			  },				
		]
		
	});
	$('.years-slider').slick({
		infinite: false,
  		slidesToShow: 1,
		autoplay: false,
		arrows: false,
	});

	let offset = 0;

	$('.years-slider-nav').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		offset = nextSlide * $('.years-line').width();
		let css_value = "translateX(" + offset + "px)";
		$('.years-line').css("transform", css_value);
	});

	$('.gallery-slider').slick({
		infinite: true,
  		slidesToShow: 1,
		autoplay: false,
		variableWidth: true,
	});	
	
	$('.screenshots').slick({
		infinite: true,
  		slidesToShow: 2,
		  responsive: [			
			{
				breakpoint: 991,
				settings: {
				  slidesToShow: 1,
				}
			  },				
		]
	});

	function mediaSize() {
		if (window.matchMedia("(max-width: 576px)").matches) {
			$("#power-bi #nav-tab").css("display", "none");
			$("#power-bi .tab-content>.tab-pane").css("display", "block");
			$("#power-bi .fade:not(.show)").css("opacity", "1");
		} else {
			$("#power-bi #nav-tab, #power-bi .tab-content>.tab-pane, #power-bi .fade:not(.show)").removeAttr("style");
		}
	}

	mediaSize();
	window.addEventListener("resize", mediaSize, false);
});

//Scroll-spy nav
jQuery(function($) {
	$(window).on('scroll', function() {
		const windowHeight = $(window).height();
		const topOffset = windowHeight/2;
		let currentTop = $(window).scrollTop() + topOffset;
		let currentH2 = null;
		const navLinks = $('#navbar-content .nav-link');
		navLinks.eq(0).addClass('active');

		$('body.single-post article.post h2, body.single-post h2.wp-block-heading, body.single-glossary article.post h2, body.single-glossary h2.wp-block-heading, h2.h2-nav').each(function() {
			let h2Offset = $(this).offset().top;
		  if (currentTop >= h2Offset) {
			currentH2 = this;
		  } else {
			return false;
		  }
		});

		if (currentH2) {
			let currentId = $(currentH2).attr('id');
		  $('nav a').removeClass('active');
		  $('nav a[href="#' + currentId + '"]').addClass('active');
		}
	  });
})

//Progress bar on articles

jQuery(function($) {
	const win = $(window);
	const doc = $(document);
	const progressBar = $('progress');
	const setValue = () => win.scrollTop();
	const setMax = () => doc.height() - win.height();
		
	progressBar.attr({ value: setValue(), max: setMax() });
	  
	doc.on('scroll', () => {
		progressBar.attr({ value: setValue() });
	});
		
	win.on('resize', () => {
		progressBar.attr({ value: setValue(), max: setMax() });
	})
})

//Animation on cards

jQuery(function($) {
	if(document.querySelector('.animated-cards')) {
		const observer = new IntersectionObserver(entries => {
				entries.forEach(entry => {
				if (entry.isIntersecting) {
					entry.target.classList.add('start-animation');
				}
				});
			});

			if(window.matchMedia("(min-width: 1200px)").matches) {
				observer.observe(document.querySelector('.animated-cards'));
			}
	}
	
});
//Blog subscription form 

jQuery(function($) {
	$('#open-subscribtion').on('click', function(){
		$('#form-wrapper').slideDown();	
		$(this).hide();	
		$('#close-subscribtion').show();
	});
	$('#close-subscribtion').on('click', function(){
		$('#form-wrapper').slideUp();	
		$(this).hide();	
		$('#open-subscribtion').show();
	});		
})

//Author subscription form 

jQuery(function($) {
	$('#open-author-subscribtion').on('click', function(){
		$('#form-wrapper').slideDown();	
		$('.right-col-info').hide();	
		$('#close-author-subscribtion').show();
		if(window.matchMedia("(max-width: 1024px)").matches) {
			$('.author-description').hide();
		}
	});
	$('#close-author-subscribtion').on('click', function(){
		$('#form-wrapper').slideUp();	
		$(this).hide();	
		$('.right-col-info').show();
		$('#open-author-subscribtion').show();
		if(window.matchMedia("(max-width: 1024px)").matches) {
			$('.author-description').show();
		}
	});		
})

//Blog Load More button

jQuery(function($) {
	let postWrapper = $('.post-wrapper');
	jQuery(document).on('click', '#load-more', function(e) {			
		e.preventDefault();
		let currentLang = $('html')[0].lang.substring(0, 2);
		let ajaxUrl = '/wp-admin/admin-ajax.php';
		let nextPage = $(this).data('page');
		let category = $(this).data('category');
		let archive = $(this).data('archive');
		let postType = $(this).data('type') ?? 'post';
		let author = $(this).data('author');
		$('.load-more-wrapper').remove();
		$('#blog-pagination').remove();
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'load_more',
				page: nextPage,
				category: category,
				archive: archive,
				postType: postType,
				author: author,
			},
			beforeSend: function() {
			jQuery("#loader").css('display', 'flex');
			},
			success: function(response) {				
				jQuery("#loader").css('display', 'none');
				postWrapper.append(response);
				if(category) {
					history.replaceState(null, '', '/'+currentLang+'/blog/page/'+ nextPage +'/?category=' + category);
				} else {
					history.replaceState(null, '', '/'+currentLang+'/blog/page/'+ nextPage +'/');
				}
				
				if($('body').hasClass('category')) {
					history.replaceState(null, '', '/'+currentLang+'/blog/category/'+ category +'/page/'+ nextPage +'/');
				}

				if($('body').hasClass('author')) {
					history.replaceState(null, '', '/'+currentLang+'/blog/author/'+ author +'/page/'+ nextPage +'/');
				}

				if($('body').hasClass('term-case-studies')) {
					history.replaceState(null, '', '/'+currentLang+'/resources/case-studies/');
				}		
			}
		});
	});
});

//Resources Load More button

jQuery(function($) {
	let postWrapper = $('.post-wrapper');
	jQuery(document).on('click', '#load-more-resources', function(e) {			
		e.preventDefault();
		let currentLang = $('html')[0].lang.substring(0, 2);
		let ajaxUrl = '/wp-admin/admin-ajax.php';
		let nextPage = $(this).data('page');
		let category = $(this).data('category');
		let archive = $(this).data('archive');
		let postType = $(this).data('type') ?? 'resources';
		$('.load-more-wrapper').remove();
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'load_more_resources',
				page: nextPage,
				category: category,
				archive: archive,
				postType: postType,
			},
			beforeSend: function() {
			jQuery("#loader").css('display', 'flex');
			},
			success: function(response) {				
				jQuery("#loader").css('display', 'none');
				postWrapper.append(response);
				if(category) {
					history.replaceState(null, '', '/'+currentLang+'/resources/' + category);
				} else {
					history.replaceState(null, '', '/'+currentLang+'/resources/'+ nextPage +'/');
				}
				if($('body').hasClass('term-case-studies')) {
					history.replaceState(null, '', '/'+currentLang+'/resources/case-studies/');
				} 
				if($('body').hasClass('page-template-archive-resources')){
					history.replaceState(null, '', '/'+currentLang+'/resources');
				}			
			}
		});
	});
});

//Glossary Load More button

jQuery(function($) {
	const postWrapper = $('.post-wrapper');
	jQuery(document).on('click', '#load-more-glossary', function(e) {			
		e.preventDefault();
		const currentLang = $('html')[0].lang.substring(0, 2);
		const ajaxUrl = '/wp-admin/admin-ajax.php';
		const nextPage = $(this).data('page');
		const category = $(this).data('category');
		const archive = $(this).data('archive');
		const postType = $(this).data('type') ?? 'glossary';
		$('.load-more-wrapper').remove();
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'load_more_glossary',
				page: nextPage,
				category: category,
				archive: archive,
				postType: postType,
			},
			beforeSend: function() {
			jQuery("#loader").css('display', 'flex');
			},
			success: function(response) {				
				jQuery("#loader").css('display', 'none');
				postWrapper.append(response);
				if(category && archive === 'glossary') {
					history.replaceState(null, '', '/'+currentLang+'/glossary/'+ '?glossary-category=' + category + '/' + nextPage);
				}
				else if(category) {
					history.replaceState(null, '', '/'+currentLang+'/glossary-category/'+ category + '/' + nextPage); 
				}
				else {
					history.replaceState(null, '', '/'+currentLang+'/glossary/'+ nextPage +'/');
				}
				if($('body').hasClass('page-template-archive-glossary')){
					history.replaceState(null, '', '/'+currentLang+'/glossary');
				}			
			}
		});
	});
});

//Filters 

jQuery(function($) {
	jQuery('.filters ul a').on('click', filter_posts);
	jQuery('.filters select').on('change', filter_posts);
	jQuery('.term-case-studies').on('click', 'a.category-label', filter_posts)

	function filter_posts(e) {
		e.preventDefault();
		$('.filters a').not($(this)).removeClass('active');
		$(this).addClass('active');
		$('.load-more-wrapper').remove();
		$('#blog-pagination').remove();						

		let postWrapper = $('.post-wrapper');
		let ajaxUrl = '/wp-admin/admin-ajax.php';
		let category = $(this).data('category');
		let postType = $(this).data('type') ?? 'post';
		let currentLang = $('html')[0].lang.substring(0, 2);
		jQuery('.filters a').each(function(i, elem) {
			if(elem.dataset.category == category) {
				elem.classList.add('active');
			} 
		})
		if (!category) {
			category = $(this).val();
		}
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'filter_posts',
				category: category,
				postType: postType,
			},

			success: function(response) {
				postWrapper.html(response);		
				if($('body').hasClass('blog')){
					if(category) {
						history.replaceState(null, '', '/'+currentLang+'/blog' + '?category=' + category);
					} else {
						history.replaceState(null, '', '/'+currentLang+'/blog');
					}
				}				
				if($('body').hasClass('archive')){
					history.replaceState(null, '', '/'+currentLang+'/resources/case-studies/');
					document.title = "Case Studies | Syteca";
				}				
			}
		});
	}
})

jQuery(function($) {
	jQuery('.filters-resources ul a').on('click', filtersResources);
	jQuery('.filters-resources select').on('change', filtersResources);

	function filtersResources(e) {
		e.preventDefault();
		$('.filters-resources a').not($(this)).removeClass('active');
		$(this).addClass('active');
		$('.load-more-wrapper').remove();					

		let postWrapper = $('.post-wrapper');
		let ajaxUrl = '/wp-admin/admin-ajax.php';
		let category = $(this).data('category');
		let postType = $(this).data('type') ?? 'resources';
		let currentLang = $('html')[0].lang.substring(0, 2);
		jQuery('.filters-resources a').each(function(i, elem) {
			if(elem.dataset.category == category) {
				elem.classList.add('active');
			} 
		})
		if (!category) {
			category = $(this).val();
		}
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'filters_resources',
				category: category,
				postType: postType,
			},

			success: function(response) {
				postWrapper.html(response);						
				if($('body').hasClass('page-template-archive-resources')){
					history.replaceState(null, '', '/'+currentLang+'/resources');
					document.title = "Resources | Syteca";
				}
				if($('body').hasClass('term-case-studies')) {
					history.replaceState(null, '', '/'+currentLang+'/resources/case-studies/');
				}			
			}
		});
	}
})

jQuery(function($) {
	jQuery('.filters-glossary ul a').on('click', filtersGlossary);
	jQuery('.filters-glossary select').on('change', filtersGlossary);

	function filtersGlossary(e) {
		e.preventDefault();
		$('.filters-glossary a').not($(this)).removeClass('active');
		$(this).addClass('active');
		$('.load-more-wrapper').remove();					

		const postWrapper = $('.post-wrapper');
		const ajaxUrl = '/wp-admin/admin-ajax.php';
		let category = $(this).data('category');
		const postType = $(this).data('type') ?? 'glossary';
		const currentLang = $('html')[0].lang.substring(0, 2);
		jQuery('.filters-glossary a').each(function(i, elem) {
			if(elem.dataset.category == category) {
				elem.classList.add('active');
			} 
		})
		if (!category) {
			category = $(this).val();
		}
		$.ajax({
			type: 'POST',
			url: ajaxUrl,
			data: {
				action: 'filters_glossary',
				category: category,
				postType: postType,
			},

			success: function(response) {
				postWrapper.html(response);						
				if($('body').hasClass('post-type-archive-glossary')){
					if(category) {
						history.replaceState(null, '', '/'+currentLang+'/glossary' + '?glossary-category=' + category);
					} else {
						history.replaceState(null, '', '/'+currentLang+'/glossary');
					}
					document.title = "Glossary | Syteca";
				}			
			}
		});
	}
})

//UP button

$(function () {  
	$(window).on('scroll', function () {  
		if ($(this).scrollTop() > 300) $('#up-btn').fadeIn(200);  
		else $('#up-btn').fadeOut(400);  
	});  
	$('#up-btn').on('click', function () {  
		$('body,html').animate({  
		scrollTop: 0  
		}, {duration: 800, easing: 'linear'}); 
	});  
}); 

//Category page mobile 

jQuery(function($) {
	$('#toggle-categories').on('click', function(){
		$('.category-list-mobile').slideToggle();	
		$(this).toggleClass('open');
	});	
})

jQuery(function($) {
    let $videoSrc;  
    $(document).on('click', '.video-btn', function() {
        $videoSrc = $(this).data( "src" );
    }); 
    jQuery('#videoResourcesModal').on('shown.bs.modal', function (e) {
        $("#video").attr('src', $videoSrc ); 
    })
    jQuery('#videoResourcesModal').on('hide.bs.modal', function (e) {
        $("#video").attr('src', $videoSrc); 
    }) 
})

jQuery(function($) {
	let currentUrl = window.location.pathname;
	$('.standard-set a').each(function() {
		let hrefValue = $(this).attr('href');
		if (hrefValue === currentUrl) {
		$(this).closest('.card-b-rounded').addClass('currentPage-item');
		}
	});
});

// Accordion scroll up
jQuery(function($) {
	if ($(window).width() <= 1200) {
		$('#accordionSwift .collapse, .card-accordion-1 .collapse, .card-accordion-2 .collapse, .new-design .accordion-faq .collapse').on('shown.bs.collapse', function(e) {
			e.preventDefault();
			const card = $(this).closest('.accordion-item, .col');
			const open = $($(this).data('parent')).find('.collapse.show');
			let additionalOffset = 0;
			if(card.prevAll().filter(open.closest('.accordion-item, .col')).length !== 0) {
				additionalOffset =  open.height();
			}
			const offsetFromTop = 178;
			$('html,body').animate({
			  scrollTop: card.offset().top - additionalOffset - offsetFromTop
			}, 500);
		  });
	}
})

// Offline License Activation and Update

const licenseForms = document.querySelectorAll(".license-form");
	let widgetId1;
	let widgetId2;
	window.onloadCallback = function() {
		const sitekey = '6Le2ZEAqAAAAAHMuzGEtoritYh9lobVVsoWUT5TR';
		widgetId1 = grecaptcha.render('recaptcha1', {
		'sitekey' : sitekey,
		});
		widgetId2 = grecaptcha.render(document.getElementById('recaptcha2'), {
		'sitekey' : sitekey
		});
	}
licenseForms.forEach(function (licenseForm) {
  licenseForm.addEventListener('submit', function (e) {
    e.preventDefault();
    const serialKeysInput = licenseForm.querySelector('#serialKeys');
    const recaptchaResponseInput = licenseForm.querySelector('.g-recaptcha-response');
	const errorMessageElementId = licenseForm.getAttribute('data-error-message');
    const errorsElement = document.getElementById(errorMessageElementId);
	const serialNumber = document.getElementById('serialNumber');
    let guid;
    let hwid;
    let captcha;
    let url;

    if (licenseForm.id === 'activation_form') {
      guid = serialKeysInput.value;
      hwid = serialNumber.value;
      captcha = recaptchaResponseInput.value;
      url = 'https://license.syteca.com/api/site/offline-activation';
    } else if (licenseForm.id === 'update_form') {
      guid = serialKeysInput.value;
      captcha = recaptchaResponseInput.value;
      url = 'https://license.syteca.com/api/site/offline-update';
    }

    const data = {
      guid,
      hwid,
      captcha
    };

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      },
      body: JSON.stringify(data)
    })
    .then(function(response) {
      if (response.status === 200) {
        return response.text();
      } else {
        return response.text().then(function(errorMessage) {
			throw new Error(errorMessage);
		  });
      }
    })
    .then(function(responseText) {
      const element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(responseText));
      element.setAttribute('download', 'activatedKeys.txt');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
	  serialKeysInput.value = '';
	  serialNumber.value = '';
    })
    .catch(function(error) {
		errorsElement.innerText = error.message;
    });

	if (licenseForm.id === 'activation_form') {
        grecaptcha.reset(widgetId1);
      } else if (licenseForm.id === 'update_form') {
        grecaptcha.reset(widgetId2);
      }
  });
});

jQuery(function($) {
	function setEqualHeight() {
			$('.row').each(function() {
				const blocks = $(this).find('.equalize-height');
				let maxHeight = -1;
				blocks.each(function() {
					let blockHeight = $(this).outerHeight();
					maxHeight = Math.max(maxHeight, blockHeight);
				});
				blocks.outerHeight(maxHeight);
			});
	}
	$(window).on('load resize', setEqualHeight);
    $(document).ready(setEqualHeight);
});

jQuery(function($) {
	$(document).ready(function() {
		$('input[type="radio"]').on('change', function() {
		  $('input[type="radio"]').parent().removeClass('selected');
		  $(this).parent().addClass('selected');
		});
	
		$('input[type="radio"]:checked').parent().addClass('selected');
	  });
});

jQuery(function($) {
    function setEqualHeightCells() {
        if ($(window).width() >= 768) {
            const rows = $('.template-4 .container .row .col .row');
            const subHeaderCells = $('.template-4 .container .row .col .sub-header');
            let subHeaderCellmaxHeight = Math.max.apply(null, subHeaderCells.map(function() {
                return $(this).outerHeight();
            }).get());
            subHeaderCells.css('min-height', subHeaderCellmaxHeight + 'px').addClass('d-flex justify-content-center align-items-center');

            rows.each(function() {
                let cols = $(this).find('.col');
                cols.each(function(index) {
                    $(this).addClass('colNum-' + (index + 1));
                });
            });

            let maxHeight = {};
            const cols = $('.template-4 .container .row .col .row .col');
            cols.each(function() {
                let col = $(this);
                let classes = col.attr('class').split(' ');
                classes.forEach(function(className) {
                    if (className.indexOf('colNum-') === 0) {
                        let num = parseInt(className.replace('colNum-', ''));
                        let height = col.outerHeight();
                        maxHeight[num] = Math.max(maxHeight[num] || 0, height);
                    }
                });
            });

            for (let num in maxHeight) {
                $('.colNum-' + num).css('min-height', maxHeight[num] + 'px').addClass('d-flex justify-content-center align-items-center');
            }
        }
    };
    $(window).on('load resize', setEqualHeightCells);
});
jQuery(function($) {
	$(document).ready(function () {
		if ($(window).width() <= 1200) {
		  $('.our-values .col, .cards-hover .col').on('click', function (e) {
			e.stopPropagation();
			if ($(this).hasClass('active')) {
			  $(this).removeClass('active');
			} else {
			  $('.our-values .col, .cards-hover .col').removeClass('active');
			  $(this).addClass('active');
			}
		  });

		  $(document).on('click', function () {
			$('.our-values .col, .cards-hover .col').removeClass('active');
		  });
		}
	  });	  
});

$(document).ready(function() {
    if ($(window).width() < 768) {
        $('.industries-card .info-indastry p:nth-of-type(3)').addClass('bright-blue');
    } 
    
    else if ($(window).width() >= 768 && $(window).width() <= 1200) {
        $('.industries-card').on('click', function (e) {
            e.stopPropagation();
            
            let targetParagraph = $(this).find('.info-indastry p:nth-of-type(3)');
            
            if (targetParagraph.hasClass('bright-blue')) {
                targetParagraph.removeClass('bright-blue');
            } else {
                $('.industries-card .info-indastry p:nth-of-type(3)').removeClass('bright-blue');
                targetParagraph.addClass('bright-blue');
            }
        });

        $(document).on('click', function () {
            $('.industries-card .info-indastry p:nth-of-type(3)').removeClass('bright-blue');
        });
    }

    if ($(window).width() <= 1200) {
        $('.industries-card').on('click', function (e) {
            e.stopPropagation();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
            } else {
                $('.industries-card').removeClass('active');
                $(this).addClass('active');
            }
        });

        $(document).on('click', function () {
            $('.industries-card').removeClass('active');
        });
    }

    if ($(window).width() >= 1200) {
        $('.industries-card').hover(
            function() {
                $(this).find('.info-indastry p:nth-of-type(3)').addClass('bright-blue');
            }, 
            function() {
                $(this).find('.info-indastry p:nth-of-type(3)').removeClass('bright-blue');
            }
        );
    }
});

jQuery(function($) {
	$(window).on('scroll', function() {
		$('.scroll-container .scroll-item').each(function() {
			let $element = $(this);
			let windowHeight = $(window).height();
			let scrollTop = $(window).scrollTop();
			let elementOffsetTop = $element.offset().top;
			let elementHeight = $element.outerHeight();
	
			let elementTopInView = elementOffsetTop - scrollTop;
			let elementBottomInView = elementTopInView + elementHeight;
	
			let topThreshold = windowHeight * 0.05;
			let bottomThreshold = windowHeight * 0.95;
	
			if (elementTopInView >= topThreshold && elementBottomInView <= bottomThreshold) {
				$element.removeClass('gray-opacity');
			} 
			else if (elementTopInView < topThreshold || elementBottomInView > bottomThreshold) {
				$element.addClass('gray-opacity');
			}
		});
	});
});

jQuery(function($) {
	$(document).ready(function() {
		function isElementInViewport(el) {
		  const rect = el.getBoundingClientRect();
		  return (
			rect.top >= 0 &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.right <= (window.innerWidth || document.documentElement.clientWidth)
		  );
		}
	  
		function runCounter($element) {
		  const target = parseInt($element.data('target'));
		  const prefix = $element.data('prefix') || '';
		  const suffix = $element.data('suffix') || '';
		  let current = 0;
		  const increment = target / 75;
	  
		  function updateCounter() {
			current += increment;
			if (current < target) {
			  $element.text(`${prefix}${Math.min(Math.ceil(current), target).toLocaleString()}${suffix}`);
			  setTimeout(updateCounter, 10);
			} else {
			  $element.text(`${prefix}${target.toLocaleString('en-US')}${suffix}`);
			}
		  }
	  
		  $element.text(`${prefix}0${suffix}`);
		  updateCounter();
		}
	  
		$(window).on('scroll', function() {
		  $('.counter').each(function() {
			const $this = $(this);
			if (isElementInViewport(this) && !$this.hasClass('counted')) {
			  $this.addClass('counted');
			  runCounter($this);
			}
		  });
		});
	  });						
});

jQuery(function($) {
	$('.load-row').on('click', function (e) {
		e.stopPropagation();
		  $('.table-block-5 .row').removeClass('hidden-row');
		  $('.table-block-5 .row').removeClass('last-row');
		  $('.load-row').addClass('d-none');
	  });
});

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', function(e) {
		e.preventDefault();
	  
		const targetId = this.getAttribute('href').substring(1);
		const targetElement = document.getElementById(targetId);
	  
		if (targetElement) {
		const offset = 178;
		const topPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
	  
		window.scrollTo({
			top: topPosition,
			behavior: 'smooth'
		});
		}
	});
});

jQuery(function($) {
	$(document).ready(function () {
		if ($(window).width() <= 1200) {
			$('.card-accordion-2 .card-b-rounded .collapsed').on('click', function() {
				const parentCard = $(this).closest('.card-b-rounded');
				if ($(this).find('a').attr('aria-expanded') === 'true') {
						parentCard.addClass('show');
				} else {
					$('.card-accordion-2 .card-b-rounded').removeClass('show');
				}
			});
		}
	  });	  
});

jQuery(function($) {
	$(document).ready(function () {
		if ($(window).width() >= 1200) {
			$('.col-xl-3.dynamic').on('mouseenter', function () {
				const $current = $(this);
				const currentTop = $current.offset().top;

				$current.addClass('hovered');
				$('.col-xl-3.dynamic').each(function () {
					const $el = $(this);
					if ($el[0] !== $current[0] && $el.offset().top === currentTop) {
						$el.addClass('shrink');
					}
				});
			});

			$('.col-xl-3.dynamic').on('mouseleave', function () {
				const $current = $(this);
				const currentTop = $current.offset().top;

				$current.removeClass('hovered');
				$('.col-xl-3.dynamic').each(function () {
					if ($(this).offset().top === currentTop) {
						$(this).removeClass('shrink');
					}
				});
			});
		}
	});
});

jQuery(function($) {
	//Accordion
	$(document).ready(function ($) {
	$('.home-accordion-with-image .accordion-item:first-child .accordion-collapse, .accordion-with-img .accordion-item:first-child .accordion-collapse').collapse({"toggle": false,});
	$('.accordion-item-card:first-child .accordion-collapse').collapse({"toggle": false,});	
	});

	$('.home-accordion-with-image .accordion-button, .home-accordion-with-image-2 .accordion-button').on('click', function(e){
		if($(this).hasClass( "collapsed" )) {
			let target = $(this).data().bsTarget;
			$(target).addClass('show');
			$(this).removeClass('collapsed');
		}
	});
});

jQuery(function($) {
function updateAccordionIndicators() {
	$('.accordion').each(function () {
		const $accordion = $(this);

		$accordion.find('.accordion-button').each(function () {
			const $button = $(this);
			let totalHeight = $button.outerHeight();

			const collapseId = $button.attr('data-bs-target');
			const $collapseEl = $(collapseId);
			const $firstParagraph = $collapseEl.find('.accordion-body p').first();

			if ($firstParagraph.length) {
				totalHeight += $firstParagraph.outerHeight();
			}

			$button.css('--accordion-before-height', totalHeight + 'px');

		});
	});
}

$(document).ready(function () {
	updateAccordionIndicators();

	$(window).on('resize', function () {
		updateAccordionIndicators();
	});

	$('.accordion-button').on('click', function () {
		setTimeout(updateAccordionIndicators, 50);
	});
});

});

jQuery(document).ready(function ($) {
    if ($("body").hasClass("page-reports-and-statistics") && $(window).width() >= 1200) {
        const $stickyTop = $("#how-it-works.section-4");
        const $horizontalWrapper = $("#how-it-works.section-4 #horizontal-wrapper");
        const $inner = $horizontalWrapper.find(".inner");

        const wrapperOffsetTop = $stickyTop.offset().top;
        const wrapperHeight = $horizontalWrapper.outerHeight();
        const windowHeight = $(window).height();
        const scrollEnd = wrapperOffsetTop + wrapperHeight - windowHeight;
        const maxScroll = $inner[0].scrollWidth - $horizontalWrapper.width();

    	$(window).on("scroll", function () {
            let windowScroll = $(window).scrollTop();
            $horizontalWrapper.removeClass("pre-sticky sticky post-sticky");

            switch (true) {
                case windowScroll >= scrollEnd:
                    $horizontalWrapper.addClass("post-sticky");
                    break;

                case windowScroll >= wrapperOffsetTop:
                    $horizontalWrapper.addClass("sticky");

                    let _start = windowScroll - wrapperOffsetTop;
                    const _end = scrollEnd - wrapperOffsetTop;
                    let pct = _start / _end;
                    let translateX = pct * maxScroll;

                    $inner.css({
                        transform: `translateX(-${translateX}px)`,
                        transition: "transform 0.1s ease-out"
                    });

                    break;

                default:
                    $horizontalWrapper.addClass("pre-sticky");
                    $inner.css("transform", "translateX(0)");
                    break;
            }
        });
    }
});
